import React from 'react';
import { AppLauncher } from '@monash/portal-react';
import { useAppLauncherItems } from '../../hooks/use-app-launcher-items';

/**
 * Legacy wrapper for AppLauncher. Can use AppLauncher or its child components directly
 */
const AppLauncherPad = () => {
  const { items } = useAppLauncherItems();

  return <AppLauncher items={items} />;
};

export default AppLauncherPad;
